/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_SellerInputs */

const vi_order_seller = /** @type {(inputs: Order_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người bán`)
};

/**

* @param {Order_SellerInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_seller = /** @type {((inputs?: Order_SellerInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_SellerInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_seller(inputs)
});